/* eslint-disable no-unused-vars */
import Vue from 'vue'
import Router from 'vue-router'
import Account from '@/views/layout/Account'
import Main from '@/views/layout/Main'
import Blank from '@/views/layout/Blank'
import Webview from '@/views/layout/Webview'

Vue.use(Router)

export const routerMap = [
  {
    name: 'HomePage',
    path: '',
    redirect: '/index'
  },
  {
    path: '/',
    redirect: '/index'
  },
  {
    component: Main,
    path: '/',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { }
      }
    ]
  },
  {
    component: Account,
    path: '/',
    children: [
      {
        path: '/user/login',
        component: () => import('@/views/user/login'),
        name: 'Login'
      },
      {
        path: '/user/register',
        component: () => import('@/views/user/register'),
        name: 'Register'
      },
      {
        path: '/user/forget',
        component: () => import('@/views/user/forget'),
        name: 'Forget'
      }
    ]
  },
  {
    component: Main,
    path: '/user',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/user/head'),
            meta: { needLogin: true, menuName: 'User' },
            children: [
              {
                path: '',
                component: () => import('@/views/user/personal'),
                meta: { needLogin: true, menuName: 'User' },
                name: 'Personal'
              },
              {
                path: 'account',
                component: () => import('@/views/user/account'),
                meta: { needLogin: true, menuName: 'User' },
                name: 'Account'
              },
              {
                path: 'vip',
                component: () => import('@/views/user/vipInfo'),
                meta: { needLogin: true, menuName: 'User' },
                name: 'VipInfo',
                props: true
              }
            ]
          },
          {
            path: 'friend',
            component: () => import('@/views/user/friend'),
            meta: { needLogin: true, menuName: 'UserFriend' },
            name: 'UserFriend'
          },
          {
            path: 'letter',
            component: () => import('@/views/user/letter'),
            meta: { needLogin: true, menuName: 'Letter' }
          }
        ]
      }
    ]
  },
  {
    component: Main,
    path: '/bank',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/bank/index'),
            meta: { needLogin: true, menuName: 'Bank' },
            name: 'Bank'
          },
          {
            path: 'create/:type',
            component: () => import('@/views/bank/create'),
            meta: { needLogin: true, menuName: 'Bank' },
            name: 'BankCreate'
          }
        ]
      }
    ]
  },
  {
    component: Main,
    path: '/game',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: 'provider/:providerId?',
            component: () => import('@/views/game/provider'),
            name: 'GameProvider',
            meta: { }
          },
          {
            path: 'bet',
            component: () => import('@/views/game/bet'),
            meta: { needLogin: true, menuName: 'Bet' },
            name: 'GameBet'
          }
        ]
      }
    ]
  },
  {
    path: '/game/launch',
    component: () => import('@/views/game/launch')
  },
  {
    component: Main,
    path: '/page',
    children: [
      {
        path: 'partner',
        component: () => import('@/views/page/partner'),
        name: 'PagePartner',
        meta: { }
      },
      {
        path: 'cooperation',
        component: () => import('@/views/page/cooperation'),
        name: 'PageCooperation',
        meta: { }
      },
      {
        path: 'privacy',
        component: () => import('@/views/page/privacy'),
        name: 'PagePrivacy',
        meta: { }
      },
      {
        path: 'about',
        component: () => import('@/views/page/about'),
        name: 'PageAbout',
        meta: { }
      },
      {
        path: 'rule',
        component: () => import('@/views/page/rule'),
        name: 'PageRule',
        meta: { }
      },
      {
        path: 'agent',
        component: () => import('@/views/page/agent'),
        name: 'PageAgent',
        meta: { }
      },
      {
        path: 'vip',
        component: () => import('@/views/page/vip')
      },
      {
        path: 'terms',
        component: () => import('@/views/page/terms')
      }
    ]
  },
  {
    component: Main,
    path: '/vip',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/vip/index'),
            name: 'Vip'
          }
        ]
      }
    ]
  },
  {
    component: Main,
    path: '/transaction',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/transaction/main'),
            meta: { needLogin: true, menuName: 'MainTransaction' }
          },
          {
            path: 'commission',
            component: () => import('@/views/transaction/commission'),
            meta: { needLogin: true, menuName: 'CommissionTransaction' }
          }
        ]
      }
    ]
  },
  {
    component: Main,
    path: '/wallet',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/wallet/index'),
            meta: { needLogin: true, menuName: 'Wallet' }
          }
        ]
      }
    ]
  },
  {
    component: Blank,
    path: '/',
    children: [
      {
        path: '/payment/deposit-return',
        component: () => import('@/views/payment/depositReturn'),
        name: 'DepositReturn'
      },
      {
        path: 'share',
        component: () => import('@/views/share'),
        name: 'Share'
      }
    ]
  },
  {
    component: Main,
    path: '/payment',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: 'deposit',
            component: () => import('@/views/payment/deposit'),
            meta: { needLogin: true },
            name: 'Deposit'
          },
          {
            path: 'deposit-record',
            component: () => import('@/views/payment/depositRecord'),
            meta: { needLogin: true, menuName: 'TransactionWallet' },
            name: 'DepositRecord'
          },
          {
            path: 'withdrawal-record',
            component: () => import('@/views/payment/withdrawalRecord'),
            meta: { needLogin: true, menuName: 'TransactionWallet' }
          },
          {
            path: 'withdrawal',
            component: () => import('@/views/payment/withdrawal'),
            meta: { needLogin: true, menuName: 'Withdrawal' }
          },
          {
            path: 'wallet',
            component: () => import('@/views/payment/wallet'),
            meta: { needLogin: true, menuName: 'Wallet' }
          }
        ]
      }
    ]
  },
  {
    component: Main,
    path: '/event',
    children: [
      {
        path: '',
        component: () => import('@/views/layout/Menu'),
        children: [
          {
            path: '',
            component: () => import('@/views/event/index'),
            name: 'eventList',
            meta: { menuName: 'Event' }
          },
          {
            path: 'me',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe' }
          },
          {
            path: 'me/:task_id',
            component: () => import('@/views/event/me'),
            meta: { needLogin: true, menuName: 'EventMe' }
          },
          {
            path: ':event_id',
            component: () => import('@/views/event/detail'),
            name: 'eventDtail',
            meta: { menuName: 'Event' }
          }
        ]
      }
    ]
  },
  {
    component: Webview,
    path: '/web',
    children: [
      {
        path: 'payment/deposit-record',
        component: () => import('@/views/payment/depositRecord'),
        meta: { needLogin: true }
      },
      {
        path: 'payment/withdrawal-record',
        component: () => import('@/views/payment/withdrawalRecord'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction',
        component: () => import('@/views/transaction/main'),
        meta: { needLogin: true }
      },
      {
        path: 'transaction/commission',
        component: () => import('@/views/transaction/commission'),
        meta: { needLogin: true }
      },
      {
        path: 'game/bet',
        component: () => import('@/views/game/bet'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true }
      },
      {
        path: 'event/me/:task_id',
        component: () => import('@/views/event/me'),
        meta: { needLogin: true, menuName: 'EventMe' }
      },
      {
        path: 'event',
        component: () => import('@/views/event/index')
      },
      {
        path: 'event/:event_id',
        component: () => import('@/views/event/detail'),
        meta: { menuName: 'Event' }
      },
      {
        path: 'user/letter',
        component: () => import('@/views/user/letter'),
        meta: { needLogin: true }
      },
      {
        path: 'vip-prize',
        component: () => import('@/views/vip/index'),
        meta: { needLogin: true }
      },
      {
        path: 'wallet',
        component: () => import('@/views/wallet/index'),
        meta: { needLogin: true }
      }
    ]
  },
  {
    component: Blank,
    path: '/web/page',
    children: [
      {
        path: 'partner',
        component: () => import('@/views/page/partner')
      },
      {
        path: 'cooperation',
        component: () => import('@/views/page/cooperation')
      },
      {
        path: 'privacy',
        component: () => import('@/views/page/privacy')
      },
      {
        path: 'about',
        component: () => import('@/views/page/about')
      },
      {
        path: 'rule',
        component: () => import('@/views/page/rule')
      },
      {
        path: 'agent',
        component: () => import('@/views/page/agent')
      },
      {
        path: 'vip',
        component: () => import('@/views/page/vip')
      }
    ]
  },
  {
    path: '/critical',
    component: () => import('@/views/errorPage/critical'),
    name: 'Critical'
  },
  {
    path: '/error',
    component: () => import('@/views/errorPage/error'),
    name: 'Error'
  },
  {
    path: '/maintain',
    component: () => import('@/views/errorPage/maintain'),
    name: 'Maintain'
  },
  {
    path: '/coming-soon',
    component: () => import('@/views/errorPage/comingSoon')
  },
  {
    path: '/forbidden',
    component: () => import('@/views/errorPage/forbidden'),
    name: 'Forbidden'
  },
  {
    path: '*',
    redirect: '/error',
    hidden: true
  },
  {
    component: Account,
    path: '/agent',
    children: [
      {
        path: '',
        component: () => import('@/views/agent/index'),
        name: 'Agent'
      },
      {
        path: 'new-member',
        component: () => import('@/views/agent/newMember'),
        name: 'NewMember'
      },
      {
        path: 'member',
        component: () => import('@/views/agent/member'),
        name: 'Member'
      }
    ]
  },
  {
    component: () => import('@/views/event/ThanksGiving'),
    path: '/Thanksgivingday',
    name: 'ThanksGiving'
  },
  {
    component: () => import('@/views/event/ThanksGiving'),
    path: '/Thanksgivingday2',
    name: 'ThanksGiving2'
  },
  {
    component: () => import('@/views/event/ThanksGiving'),
    path: '/Thanksgivingday3',
    name: 'ThanksGiving3'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas2'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas3'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas4'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas5'
  },
  {
    component: () => import('@/views/event/Xmas'),
    path: '/Xmas6'
  }
]

export default new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name === 'Index') return
    else return { y: 0 }
  },
  routes: routerMap
})
